

    /**
     * Safer Object.hasOwnProperty
     */
     function hasOwn(obj, prop){
         return Object.prototype.hasOwnProperty.call(obj, prop);
     }

     module.exports = hasOwn;





//////////////////
// WEBPACK FOOTER
// ./node_modules/mout/object/hasOwn.js
// module id = E7yG
// module chunks = 0